function HeroMainSpicy() {
  return (
    <svg
      width={632}
      height={518}
      viewBox="0 0 632 518"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M0.919219 169.695L85.2956 214.427L149.841 209.031L250.121 262.193"
          stroke="url(#paint0_linear_0_1)"
          strokeOpacity="0.25"
        />
        <path
          d="M0.919219 169.695L85.2956 214.427L149.841 209.031L250.121 262.193"
          stroke="url(#paint1_linear_0_1)"
          strokeOpacity="0.31"
        />
      </g>
      <path
        opacity="0.4"
        d="M503 130.5L428 82.5L430 0.5"
        stroke="url(#paint2_linear_0_1)"
        strokeOpacity="0.3"
      />
      <path
        opacity="0.4"
        d="M583.558 170.558L630.54 202.424V305.662L581.043 355.159"
        stroke="url(#paint3_linear_0_1)"
        strokeOpacity="0.3"
      />
      <g opacity="0.5">
        <path
          d="M607 376.156L495.155 376.156L433.5 410"
          stroke="url(#paint4_linear_0_1)"
          strokeOpacity="0.4"
        />
        <path
          d="M607 376.156L495.155 376.156L433.5 410"
          stroke="url(#paint5_linear_0_1)"
          strokeOpacity="0.31"
        />
      </g>
      <g opacity="0.5">
        <path
          d="M138 518V400.363L274 356"
          stroke="url(#paint6_linear_0_1)"
          strokeOpacity="0.21"
        />
        <path
          d="M138 518V400.363L274 356"
          stroke="url(#paint7_linear_0_1)"
          strokeOpacity="0.55"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_0_1"
          x1="131.729"
          y1="199.429"
          x2="108.309"
          y2="243.605"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.277303" stopColor="#676B9C" />
          <stop offset={1} stopColor="#242536" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_0_1"
          x1="86.7256"
          y1="204.346"
          x2="521.301"
          y2="426.765"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0674891" stopColor="#368DFF" stopOpacity={0} />
          <stop offset="0.206121" stopColor="#368DFF" />
          <stop offset="0.207969" stopColor="#368DFF" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_0_1"
          x1={428}
          y1="19.5"
          x2={434}
          y2={113}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242536" stopOpacity={0} />
          <stop offset="0.783671" stopColor="#676B9C" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_0_1"
          x1="608.973"
          y1="327.228"
          x2="619.226"
          y2="181.211"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242536" stopOpacity={0} />
          <stop offset="0.783671" stopColor="#676B9C" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_0_1"
          x1="439.078"
          y1="391.499"
          x2="568.046"
          y2="417.182"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.277303" stopColor="#676B9C" />
          <stop offset={1} stopColor="#242536" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint5_linear_0_1"
          x1="503.235"
          y1="411.686"
          x2="521.638"
          y2="318.759"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0674891" stopColor="#368DFF" stopOpacity={0} />
          <stop offset="0.206121" stopColor="#368DFF" />
          <stop offset="0.207969" stopColor="#368DFF" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint6_linear_0_1"
          x1={206}
          y1={356}
          x2={206}
          y2="539.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.494694" stopColor="#676B9C" />
          <stop offset="0.86403" stopColor="#242536" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint7_linear_0_1"
          x1="164.937"
          y1="453.698"
          x2="436.373"
          y2="431.233"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0674891" stopColor="#368DFF" stopOpacity={0} />
          <stop offset="0.277053" stopColor="#368DFF" />
          <stop offset="0.283266" stopColor="#368DFF" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>

  );
}

export default HeroMainSpicy;